import React, { memo } from 'react';
import propTypes from 'prop-types';
import dayjs from 'dayjs-ext';
import { DATE_MONTH_DAY_YEAR, TIME_FORMAT } from 'src/ui/const';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function TableDate({ value, showTime }) {
  const date = dayjs(value);

  return (
    <p className="table-date">
      <span className="is-size-7">{date.format(DATE_MONTH_DAY_YEAR)}</span>
      {showTime && (
        <>
          <br />
          <span className="is-size-7 has-text-grey-medium-dark">
            <span className="icon is-small">
              <FontAwesomeIcon
                icon={['fal', 'clock']}
                size="xs"
                className="has-text-grey"
              />
            </span>
            {date.format(TIME_FORMAT)}
          </span>
        </>
      )}
    </p>
  );
}

TableDate.defaultProps = {
  showTime: false,
};

TableDate.propTypes = {
  value: propTypes.string.isRequired,
  showTime: propTypes.bool,
};

const memoizedTableDate = memo(TableDate);

export { memoizedTableDate as TableDate };
